<template>
  <div class="tabs_content">
    <section v-show="$_readActionAllowedAll">
      <div class="left">
        <h2 v-translate>Výběr operátora</h2>
      </div>
      <div class="right">
        <div class="field_left">
          <operator-select
              v-model="entity.id_operator"
              :options="operatorOptions"
              :disabled="true"
          >
          </operator-select>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
        >
          <p>
            <translate class="translate">Počet zařízení</translate>
            : {{ entity.device_count }}
          </p>
        </detail-entity-info>
      </div>
      <basic-info
          :entity="entity"
          ref="basicinforef"
          :is-editable="$_updateActionAllowed"
      />
    </section>
    <contact
        :subscriber="entity"
        ref="contactref"
        :is-editable="$_updateActionAllowed"
    />
    <settings
        :subscriber="entity"
        :subjectTypeOptions="subjectTypes"
        :subscriberTypeOptions="subscriberTypes"
        :is-editable="$_updateActionAllowed"
        :password-editable="$_updateActionAllowed && hasEmail"
        ref="settingsref"
        @set-password="$emit('set-password', arguments[0])"
        @resetPassword="resetSubscriberPassword"
    />
    <section class="buttons">
      <p>
        <router-link
            :to="{ name: moduleName }"
            class="btn btn_back btn_seznam"
            v-translate>Seznam
        </router-link>
        <input
            v-if="$_updateActionAllowed"
            type="submit"
            :value="'Uložit vlastnosti' | translate"
            class="btn"
            @click.prevent.stop="submitForm()"
        />
      </p>
    </section>
  </div>
</template>
<script>
import BasicInfo from "@/components/views/subscribers/settings/BasicInfo"
import Contact from "@/components/views/subscribers/settings/Contact"
import DetailEntityInfo from "@/components/common/DetailEntityInfo.vue"
import OperatorSelect from "@/components/common/OperatorSelect.vue"
import Settings from "@/components/views/subscribers/settings/Settings"
import detailActions from "@/components/mixins/detail-actions"
import subscriberData from "@/components/mixins/subscriber-data"
import selectOperator from "@/components/mixins/select-operator-business-model"
import message from "@/components/mixins/message"

export default {
  name: "SubscriberDetailSettigs",
  components: {
    BasicInfo,
    Contact,
    DetailEntityInfo,
    OperatorSelect,
    Settings,
  },
  mixins: [detailActions, message, selectOperator, subscriberData],
  props: {
    entity: Object,
    oldEmail: String,
  },
  data() {
    return {
      moduleName: 'subscribers',
    }
  },
  created(SubscriberService, OperatorService) {
    this.entityService = SubscriberService
    this.operatorService = OperatorService
    this.getOperators()
    this.getFormFilterData(this.entity.id_operator)
  },
  computed: {
    hasEmail() {
      if (this.oldEmail) {
        return this.oldEmail.length > 0;
      } else {
        return false;
      }
    }
  },
  methods: {
    submitForm() {
      this.$emit('submitForm')
    },
    resetSubscriberPassword(params) {
      this.entityService.resetSubscriberPassword(this.entity.id, params)
          .then((data) => {
            this.setSuccessMessage(this.$gettextInterpolate("Nové heslo bylo úspěšně odesláno na e-mail %{email}", { email: this.entity.email }));
          })
          .catch(error => {
            error['validation_errors'].forEach(error => {
              let errorMessage;

              if (error === "Receiver email address is not defined.") {
                errorMessage = this.$gettext('Odběratel nemá definovanou adresu, na kterou by mohl být zaslán email s heslem.')
              } else if (error === "Default sender email address is not defined.") {
                errorMessage = this.$gettext('Není definována kontaktní adresa odesilatele.')
              } else if (this._.includes(error, 'No email template for message type')) {
                errorMessage = this.$gettext('Není definována šablona emailu pro reset hesla.')
              } else {
                errorMessage = error;
              }
              this.setErrorMessage(errorMessage);
            });
          })
    },
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/settings/SettingsTab.vue